/**
 *ng-model改版 
 */
"use strict";
angular.module("ngModelFixModule", []).
directive("ngModelFix", ["$timeout", function($timeout) {
    return {
        restrict: "A",
        scope: false,
        require: 'ngModel',
        link: function(scope, $elem, $attrs, ctrl) {
            var initIndex = 0;
            var watcher = scope.$watch($attrs.ngModel, function(nv, ov) {
                if (initIndex > 0) {
                    watcher();
                }
                if (nv !== undefined && nv !== "") {
                    nv = nv.replace(/&amp;/g, "&");
                    ctrl.$$ngModelSet(scope, nv);
                    initIndex++;
                }
            });
        }
    };
}]);